import React, { Component } from "react";
import { Helmet } from "react-helmet";
import "./MasterMedicinaList.css";
import { ROUTES } from "const";
import { MSection, Title } from "components/misc";
import { MASTERS } from "./master-data";

const IMAGE_PATH = "/img/master-medicina";
const COURSE_PATH = ROUTES.MASTER_MEDICINA_DETAIL;

export class MasterMedicinaList extends Component {

    render() {

        const title = "Master Universitari Area Medica";

        return (
            <>
                <Helmet>
                    <title>{title}</title>
                    <meta property="og:title" content={title} />
                    <meta property="og:description" content="Scopri i nostri master universitari nell'area medica" />
                </Helmet>
                <MSection >
                    <div className="text-center">
                        <Title>{title}</Title>
                        <p className="mt-3">I Master Universitari Online di 1° e 2° livello e i Corsi di Formazione Professionale dell’Università UniCamillus sono concepiti per offrire conoscenze accademiche avanzate in grado di rispondere alle esigenze dei professionisti in cerca di formazione specialistica e aggiornamento. </p>
                    </div>
                </MSection>
                <section className="master-medicina-list" aria-labelledby="master-medicina-title">


                    <div className="master-medicina-list__container">

                        <ul className="master-medicina-list__grid">
                            {MASTERS.map((master) => (
                                <li className="master-medicina-list__item" key={master.code}>
                                    <a
                                        className="master-medicina-card"
                                        href={`${COURSE_PATH}/${master.slug}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label={`${master.title} [COD. ${master.code}] (si apre in una nuova scheda)`}
                                    >
                                        <div className="master-medicina-card__media">
                                            <img
                                                className="master-medicina-card__image"
                                                src={`${IMAGE_PATH}/${master.image}`}
                                                alt=""
                                                loading="lazy"
                                                decoding="async"
                                            />
                                            <span className="master-medicina-card__badge">Iscrizioni aperte</span>
                                        </div>
                                        <div className="master-medicina-card__body">
                                            <span className="master-medicina-card__label">
                                                {master.showMedal && (
                                                    <img
                                                        className="master-medicina-card__medal"
                                                        src={`${IMAGE_PATH}/master-primo-livello.svg`}
                                                        alt=""
                                                        width="20"
                                                        height="20"
                                                    />
                                                )}
                                                {master.label}
                                            </span>
                                            <h5 className="master-medicina-card__title">
                                                {master.title} [COD. {master.code}]
                                            </h5>
                                        </div>
                                        <div className="master-medicina-card__footer">
                                            <span>{master.duration}</span>
                                            <span>60 crediti</span>
                                            <span>Italiano</span>
                                        </div>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>
            </>
        );
    }
}
